
import { imageToBase64, base64ToFile } from "@/assets/js/filters.js";
import verification from "@/components/verificationCode/verification.vue";
import {
  getLiveProfileRewardFields,
  getProfileRewardRefreshRetry,
  isDefaultAvatar,
  isEmptySelectValue,
  readProfileReward,
} from "@/utils/profileReward.js";

export default {
  props: ["randCode", "userInfoForm"],
  components: { verification },
  data() {
    return {
      loading: false,
      profileReward: null, // settings.profile_reward，展示与发奖只认该对象字段
      profileRewardDismissed: false, // 本次 Toast 后隐藏奖励条，不持久化已领取标记
      isPresetAvatar: false, // 打开时是否为系统默认头像
      avatarPicked: false, // 本次点选预设头像或自己上传，算头像已完善
      initialNickname: "", // 打开弹窗时的昵称，用来判断是否改过
      nicknameEdited: false, // 昵称输入框已改成新文案
      lastSaveAt: 0, // 保存按钮上次点击时间，用于防连点
      username: "",
      bgColor: ["linear-gradient(88deg, #FEEAF5 0%, #FFEFE7 100%)"],
      user_info: {
        background_img: "",
        nickname: "",
        habits: "",
      },
      usermedal_list: [],
      user_score_config: [],
      country_list_arr: [],
      //个人信息
      userInfoImg: "",
      headData: [
        {
          img: require("../../assets/image/userinfoForm/headImg.png"),
          active: false,
        },
        {
          img: require("../../assets/image/userinfoForm/headImg2.png"),
          active: false,
        },
        {
          img: require("../../assets/image/userinfoForm/headImg3.png"),
          active: false,
        },
        {
          img: require("../../assets/image/userinfoForm/headImg4.png"),
          active: false,
        },
      ],
      dialogVisibleHead: false, //头像弹窗
      imgNmber: 0,
      upload_img: [],
      dialogVisible: true,
      hobby_list: [],
      fileList: [],
      dialogWidth: "30%", //模态框默认宽度
      headDialogWidth: "20%", //头像模态框宽度
      userImg_list: [
        {
          url_off: require("../../assets/image/userinfoForm/creator.png"),
          url_on: require("../../assets/image/userinfoForm/creator_on.png"),
          name: "creator",
          is_select: 0,
          is_default: 0,
          id: "",
        },
        {
          url_off: require("../../assets/image/userinfoForm/popularity.png"),
          url_on: require("../../assets/image/userinfoForm/popularity_on.png"),
          name: "Popularity",
          is_select: 0,
          is_default: 0,
          id: "",
        },
        {
          url_off: require("../../assets/image/userinfoForm/super-ldol.png"),
          url_on: require("../../assets/image/userinfoForm/ldol_on.png"),
          name: "Super ldol",
          is_select: 0,
          is_default: 0,
          id: "",
        },
        {
          url_off: require("../../assets/image/userinfoForm/xfan.png"),
          url_on: require("../../assets/image/userinfoForm/xpen_on.png"),
          name: "Xp-Pen Certified Artist",
          is_select: 0,
          is_default: 0,
          id: "",
        },
        {
          url_off: require("../../assets/image/userinfoForm/level.png"),
          url_on: require("../../assets/image/userinfoForm/xfan_on.png"),
          name: "Commentator",
          is_select: 0,
          is_default: 0,
          id: "",
        },
        {
          url_off: require("../../assets/image/userinfoForm/collector.png"),
          url_on: require("../../assets/image/userinfoForm/collector_on.png"),
          name: "Collector",
          is_select: 0,
          is_default: 0,
          id: "",
        },
        {
          url_off: require("../../assets/image/userinfoForm/popularity.png"),
          url_on: require("../../assets/image/userinfoForm/popularity_on.png"),
          name: "Xfans",
          is_select: 0,
          is_default: 0,
          id: "",
        },
        {
          url_off: require("../../assets/image/userinfoForm/certified_artist.png"),
          url_on: require("../../assets/image/userinfoForm/commentator_on.png"),
          name: "Level",
          is_select: 0,
          is_default: 0,
          id: "",
        },
      ],
      imgIndex: 0,
      ossConfig: {},
      captchaCode: "",
      uploadloading:false,//自定义上传头像loading
      uploadlPercentage:0,
    };
  },
  computed: {
    /** 只认 show_banner === true；本次 Toast 后不再展示 */
    showProfileReward() {
      return (
        this.profileReward &&
        this.profileReward.show_banner === true &&
        this.profileRewardDismissed !== true
      );
    },
    profileRewardFields() {
      return getLiveProfileRewardFields(this.profileReward, this.user_info, {
        isPresetAvatar: this.isPresetAvatar,
        avatarPicked: this.avatarPicked,
        is_default_face: this.avatarPicked ? 0 : this.user_info && this.user_info.is_default_face,
        nicknameEdited: this.nicknameEdited,
      });
    },
    profileRewardCompletedCount() {
      return this.profileRewardFields.filter((item) => item.done).length;
    },
    profileRewardTotalCount() {
      return Number(this.profileReward && this.profileReward.total_count);
    },
    isProfileComplete() {
      return (
        this.profileRewardFields.length > 0 &&
        this.profileRewardFields.every((item) => item.done)
      );
    },
    profileRewardProgressPercent() {
      const total = this.profileRewardTotalCount;
      if (!Number.isFinite(total) || total <= 0) {
        return 0;
      }
      return Math.round((this.profileRewardCompletedCount / total) * 100);
    },
    profileRewardPoints() {
      return Number(this.profileReward && this.profileReward.show_points);
    },
    saveButtonText() {
      if (this.showProfileReward && this.isProfileComplete) {
        return this.$t("page.PROFILE_REWARD_SAVE_EARN", { n: this.profileRewardPoints });
      }
      return this.$t("page.SAVE");
    },
    formRules() {
      return {
        nickname: [
          {
            required: true,
            message: this.$t("page.NICKNAME_HINT"),
            trigger: "",
          },
          {
            min: 3,
            max: 20,
            message: this.$t("page.NICKNAME_LENGTH"),
            trigger: "",
          },
        ],
        hobby_list: [{ validator: this.validateHobby, trigger: "blur" }],
        country_id: [
          {
            required: true,
            message: this.$t("page.PLEASE_SELECT_COUNTRY"),
            trigger: "change",
          },
        ],
        gender: [
          {
            required: true,
            message: this.$t("page.PLEASE_SELECT_GENDER"),
            trigger: "change",
          },
        ],
        age: [{ validator: this.validateAge, trigger: "blur" }],
        habits: [
          {
            required: true,
            message: this.$t("page.PLEASE_CHOOSE_HAND"),
            trigger: "change",
          },
        ],
        signature: [{ type: "date", required: true, message: "", trigger: "change" }],
      };
    },
  },
  methods: {
    validateHobby(rule, value, callback) {
      const res = this.hobby_list.findIndex((item) => item.is_hobby == 1);
      if (res == -1) {
        callback(new Error(this.$t("page.HOBBY_CHOOSE_ERROR")));
        return;
      }
      callback();
    },
    validateAge(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("page.AGE_EMPTY")));
        return;
      }
      setTimeout(() => {
        if (!Number.isInteger(parseInt(value))) {
          callback(new Error(this.$t("page.AGE_NUMERIC")));
        } else {
          callback();
        }
      }, 1000);
    },
    // 个人修改

    async userinfoUpadate() {
      let prize = [];
      let label = [];
      this.upload_img.filter(function (currentValue, index) {
        console.log(currentValue);
        prize.push(currentValue.url);
      });
      label = this.getSelectedMedalIds();
      let user = {
        age: this.user_info.age,
        nickname: this.user_info.nickname.toString(),
        country: this.user_info.country_id.toString(),
        province: this.user_info.province_id.toString(),
        label_id: this.user_info.user_label.toString(),
        background_img: this.user_info.background_img.toString(),
        gender: this.user_info.gender.toString(),
        signature: this.user_info.signature.toString(),
        face_url: this.user_info.user_thumb_compress.toString(),
        habits: this.user_info.habits.toString(),
        hobby: this.user_info.hobby.toString(),
        prize: prize.toString(),
        rand_code: this.randCode,
        medal: label.toString(),
        check_str: this.captchaCode.toString(),
      };
      console.log(user);
      let res = await this.$global.userinfoUpdate(user);

      if (res.code === 200) {
        this.closeCaptchaDialog();
        if (this.$parent.getUserInfo) {
          this.$parent.getUserInfo();
        }
        // 保存接口 /user.info/user_edit 直接返回 profile_reward，优先用这份定位未完成项
        const saveReward = readProfileReward(res.data && res.data.profile_reward);
        if (saveReward) {
          this.applyProfileReward(saveReward);
        }
        let reward = saveReward;
        if (!saveReward) {
          reward = await this.refreshProfileRewardWithRetry();
        } else if (saveReward.is_all_complete === true && saveReward.show_toast !== true) {
          reward = (await this.refreshProfileRewardWithRetry()) || saveReward;
        }
        // 验证码关完后再关资料弹窗，避免嵌套弹窗把父层留住
        this.$nextTick(() => {
          this.handleSaveSuccess(reward);
        });
        return;
      }
      if (res.code === 509) {
        this.openCaptchaDialog();
        return;
      }
      if (this.$refs.verification && this.$refs.verification.dialogVisible) {
        this.$refs.verification.getCaptcha();
        this.$refs.verification.captchaCode = "";
      }
      this.captchaCode = "";
      this.$message.error(res.msg);
    },

    //
    handleExceed(files, fileList) {
      console.log(files);
      this.$message.warning(this.$t("page.UPLOAD_FILE_LIMIT_WARNING"));
    },
    handleImgToBase64(url, cb) {
      let that = this;
      var image = new Image();
      image.crossOrigin = "";
      image.src = url;
      image.onload = function () {
        let base64 = imageToBase64(image); //图片转base64
        var formData = new FormData();
        formData.append("file", base64ToFile(base64));
        formData.append("rand_code", that.randCode);
        formData.append("log_type", 3);
        // let file = base64ToFile(base64, "file"); //base64转File
        // var formData = new FormData();
        // formData.append('file', file);
        // formData.append('rand_code',this.randCode);
        // formData.append('log_type',3);
        // 根据自身需求调整【因个人项目逻辑不一样，这里使用回调函数】
        cb && typeof cb == "function" && cb(formData);
        console.log(formData);
        // return formData;
      };
    },
    // 头像默认点击
    async clickHeadImg(index) {
      let that = this;
      let url = this.headData[index].img;
      this.handleImgToBase64(url, async (res) => {
        let result = await this.$global.formViaUpload(res);
        if (result.code == 200) {
          // result.data = this.user_info.face_url
          that.user_info.user_thumb_compress = result.data;
          that.user_info.is_default_face = 0;
          that.$store.state.userInfo.userInfo.face_url = result.data;
          that.avatarPicked = true; // 点选给出的预设头像也算完善
          that.isPresetAvatar = false;
          that.dialogVisibleHead = false;
        }
        // console.log(result, 'result');
        this.headData.forEach((element) => {
          element.active = false;
        });
        this.headData[index].active = true;
      });
    },
    // 头像关闭
    handleCloseHead(done) {
      done();
    },
    handleClose(done) {
      this.$emit("getVisible", false);
      done();
    },
    sendSchoolName() {
      // this.$emit('studentEvent',false)
    },
    /** 相对打开时的昵称有改动且非空，才算本次完善了昵称 */
    markNicknameEdited() {
      const current = String((this.user_info && this.user_info.nickname) || "").trim();
      const initial = String(this.initialNickname || "").trim();
      this.nicknameEdited = current.length > 0 && current !== initial;
    },
    /** 验证码已打开则不再重复弹出 */
    openCaptchaDialog() {
      const captcha = this.$refs.verification;
      if (!captcha || captcha.dialogVisible) {
        return;
      }
      captcha.changeVisible(true);
      captcha.getCaptcha();
    },
    /** 验证码弹窗点提交后走同一套保存，带独立 loading */
    async triggerMethod() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.lastSaveAt = Date.now();
      try {
        await this.userinfoUpadate();
      } finally {
        this.loading = false;
      }
    },
    /** 保存按钮防连点：间隔内或请求中直接忽略 */
    beforeSubmitForm(formName) {
      const SAVE_DEBOUNCE_MS = 800;
      const now = Date.now();
      const captchaOpen = this.$refs.verification && this.$refs.verification.dialogVisible;
      if (this.loading || captchaOpen || now - this.lastSaveAt < SAVE_DEBOUNCE_MS) {
        return;
      }
      this.lastSaveAt = now;
      this.loading = true;
      this.submitForm(formName);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          this.loading = false;
          return;
        }
        this.userinfoUpadate().finally(() => {
          this.loading = false;
        });
      });
    },
    /** 写入 profile_reward，只认该对象（settings / user_edit 均可） */
    applyProfileReward(raw) {
      this.profileReward = readProfileReward(raw);
      this.$emit("profile-reward-updated", this.profileReward);
    },
    /** 回查 /user.info/settings 的 profile_reward */
    async fetchProfileRewardFromSettings() {
      try {
        const res = await this.$global.userinfoRecord();
        if (res && res.code === 200 && res.data) {
          this.applyProfileReward(res.data.profile_reward);
          return this.profileReward;
        }
      } catch (e) {}
      return null;
    },
    /**
     * 保存成功后回查奖励是否发放。
     * is_received === true 或 show_toast === true 则停止；否则最多补偿 3 次。
     */
    async refreshProfileRewardWithRetry() {
      const maxRetry = getProfileRewardRefreshRetry();
      let reward = null;
      for (let i = 0; i < maxRetry; i++) {
        reward = await this.fetchProfileRewardFromSettings();
        if (reward && (reward.is_received === true || reward.show_toast === true)) {
          return reward;
        }
      }
      return reward;
    },
    /** 关掉验证码弹窗，避免挡住修改成功提示 */
    closeCaptchaDialog() {
      if (this.$refs.verification) {
        this.$refs.verification.captchaCode = "";
        this.$refs.verification.changeVisible(false);
      }
      this.captchaCode = "";
    },
    /**
     * 修改成功提示。第一次完善资料时追加 +point X-Coins，只认 profile_reward.point。
     */
    getSaveSuccessMessage(reward) {
      const point = Number(reward && reward.point);
      const plusText =
        reward &&
        reward.is_all_complete === true &&
        Number.isFinite(point) &&
        point > 0
          ? ` +${point} X-Coins`
          : "";
      if (reward && reward.show_toast === true && reward.toast_message) {
        return reward.toast_message;
      }
      return `${this.$t("page.MODIFY_SUCCESS")}${plusText}`;
    },
    /** 保存成功后关闭资料弹窗，资料未全部完善也关闭 */
    handleSaveSuccess(reward) {
      const point = Number(reward && reward.point);
      const isFirstComplete =
        reward &&
        reward.is_all_complete === true &&
        Number.isFinite(point) &&
        point > 0;
      const duration =
        reward && reward.show_toast === true && Number(reward.toast_duration_ms) > 0
          ? reward.toast_duration_ms
          : 3000;
      this.$message({
        message: this.getSaveSuccessMessage(reward),
        type: "success",
        duration,
        offset: 200,
        onClose: () => {
          if (isFirstComplete || (reward && reward.show_toast === true)) {
            this.hideProfileRewardUi();
          }
        },
      });
      this.dialogVisibleHead = false;
      this.dialogVisible = false;
      this.$emit("getVisible", false);
      if (this.$parent.handUserInfoRecord) {
        this.$parent.handUserInfoRecord();
      }
    },
    hideProfileRewardUi() {
      this.profileRewardDismissed = true;
      this.$emit("profile-reward-claimed");
    },
    /**
     * 按表单顺序定位第一个未完成项并聚焦。
     * 头像未完成时滚到头像并打开更换头像；其余 8 项滚到对应控件并聚焦输入框。
     */
    scrollToFirstIncompleteField() {
      const fieldOrder = [
        "face_url",
        "nickname",
        "gender",
        "age",
        "country",
        "habits",
        "label_id",
        "hobby",
        "signature",
      ];
      const first = fieldOrder
        .map((key) => this.profileRewardFields.find((item) => item.param_key === key))
        .find((item) => item && !item.done);
      if (!first || !first.ref) {
        return;
      }
      const comp = this.$refs[first.ref];
      const el = comp && (comp.$el || comp);
      if (!el) {
        return;
      }
      const scroller = el.closest && el.closest(".el-dialog__body");
      if (scroller) {
        const top =
          el.getBoundingClientRect().top -
          scroller.getBoundingClientRect().top +
          scroller.scrollTop -
          16;
        scroller.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
      } else if (typeof el.scrollIntoView === "function") {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      if (first.param_key === "face_url") {
        this.dialogVisibleHead = true;
        return;
      }
      const input = el.querySelector && el.querySelector("textarea, .el-input__inner, input");
      if (input && typeof input.focus === "function") {
        this.$nextTick(() => {
          input.focus();
        });
      }
    },
    /** 未填写时不展示 0，统一走请输入/请选择 */
    normalizeEmptyProfileValues() {
      if (isEmptySelectValue(this.user_info.gender)) {
        this.$set(this.user_info, "gender", "");
      }
      if (isEmptySelectValue(this.user_info.age)) {
        this.$set(this.user_info, "age", "");
      }
      if (isEmptySelectValue(this.user_info.country_id)) {
        this.$set(this.user_info, "country_id", "");
      }
      if (isEmptySelectValue(this.user_info.habits)) {
        this.$set(this.user_info, "habits", "");
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleButtonSelected() {
      // 主动触发点击事件
      // this.$refs.selectFiles.dispatchEvent(new MouseEvent('click'));
    },
    async getPession() {
      // let res = await this.$global.userInfoDiscussion({ "page": "1", "order_type": type })
      let res = await this.$global.releaseConfigure();
      res.data.tag_list.forEach((item) => {
        item.active = false;
        item.bgColor = "";
      });
      res.code == 200 ? (this.ruleForm.tag_list = res.data.tag_list) : "";
    },
    //    删除照片
    handleRemove(file, fileList) {
      this.upload_img = [];
      fileList.filter((cureentValue, index) => {
        this.upload_img.push({ url: cureentValue.url });
      });
      if (this.upload_img.length < 3) {
        this.$refs.addText.parentNode.style.display = "";
      }
    },
    handlePictureCardPreview(file) {
      // console.log(file.url);
      this.ruleForm.dialogImageUrl = file.url;
      this.ruleForm.dialogVisible = true;
    },
    handleDownload(file) {
      // console.log(file);
    },
    // 上传图片
    handleAvatarSuccess(file, fileList) {
      // this.upload_img = fileList
      // console.log(file);
    },
    handleAvatarSuccessHead(file, fileList) {
      // this.userInfoImg = fileList
    },
    beforeAvatarUpload(file) {
      let index = file.name.lastIndexOf(".");
      let extn = file.name.substr(index + 1);
      let isFormat =
        ["png", "jpg", "jpeg", "gif", "bmp", "HEIC"].indexOf(extn.toLowerCase()) != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isFormat) {
        this.$message.error(this.$t("page.UPLOAD_IMAGE_FORMAT_ERROR"));
        return false;
      }
      if (!isLt5M) {
        this.$message.error(this.$t("page.UPLOAD_IMAGE_SIZE_5MB"));
        return false;
      }
      if (isFormat && isLt5M) {
        this.uploading = true;
      }
    },

    // 点击上传头像
    uploadFile() {
      this.dialogVisibleHead = true;
    },
    /** 用 settings 的副本填表，未保存的修改不写回父组件 */
    getUserInfo() {
      const raw = this.userInfoForm && this.userInfoForm.user_info;
      if (!raw) {
        return;
      }
      const userInfo = JSON.parse(JSON.stringify(raw));
      const labels = Array.isArray(userInfo.user_label) ? userInfo.user_label : [];
      const hobbies = Array.isArray(userInfo.hobby) ? userInfo.hobby : [];
      userInfo.user_label = labels.map((item) =>
        item && typeof item === "object" ? item.label_id : item
      );
      userInfo.hobby = hobbies.map((item) =>
        item && typeof item === "object" ? item.id : item
      );
      if (userInfo.prize == null) {
        userInfo.prize = "";
      }
      if (userInfo.habits == null) {
        userInfo.habits = "";
      }
      this.user_info = userInfo;
      this.user_score_config = this.userInfoForm.user_score_config;
      this.country_list_arr = this.userInfoForm.country_list_arr;
      this.hobby_list = this.userInfoForm.hobby_list;
      this.usermedal_list = Array.isArray(this.userInfoForm.usermedal_list)
        ? this.userInfoForm.usermedal_list
        : [];
      this.username = userInfo.nickname;
      this.initialNickname = String(userInfo.nickname || "");
      this.nicknameEdited = false;
      this.avatarPicked = false;
      this.upload_img = [];
      if (userInfo.prize) {
        String(userInfo.prize)
          .split(",")
          .filter((url) => url)
          .forEach((url) => {
            this.upload_img.push({ url });
          });
      }
      this.headData.forEach((item) => {
        item.active = false;
      });
      this.syncMedalList();
      this.normalizeEmptyProfileValues();
      const avatarUrl =
        this.user_info.user_thumb_compress ||
        this.user_info.user_thumb_face_url ||
        this.user_info.face_url;
      this.isPresetAvatar =
        this.user_info.is_default_face === 1 ||
        isDefaultAvatar(avatarUrl, {
          is_default_face: this.user_info.is_default_face,
        });
      this.applyProfileReward(this.userInfoForm && this.userInfoForm.profile_reward);
    },
    /** 把 settings.usermedal_list 的 id / 选中态同步到展示列表 */
    syncMedalList() {
      this.imgIndex = 0;
      this.usermedal_list.forEach((currentValue, index) => {
        const target = this.userImg_list[index];
        if (!target) {
          return;
        }
        const medalId = currentValue.id || currentValue.medal_id || "";
        this.$set(target, "id", medalId);
        this.$set(target, "is_select", Number(currentValue.is_select) === 1 ? 1 : 0);
        this.$set(target, "is_default", Number(currentValue.is_default) === 1 ? 1 : 0);
        if (Number(target.is_select) === 1) {
          this.imgIndex += 1;
        }
      });
    },
    /** 已勾选且有 id 的勋章，提交时拼成 medal */
    getSelectedMedalIds() {
      return this.userImg_list
        .filter((item) => Number(item.is_select) === 1 && item.id !== "" && item.id != null)
        .map((item) => item.id);
    },
    /**
     * 切换勋章展示。旧逻辑要求 is_default == 0 且依赖 usermedal_list[index]，
     * 未解锁或列表对不齐时点不了，medal 一直为空。
     */
    handleUserMelal(item, index) {
      const medal = this.userImg_list[index];
      if (!medal) {
        return;
      }
      const source = this.usermedal_list[index] || {};
      const medalId = medal.id || source.id || source.medal_id || "";
      if (medalId === "") {
        return;
      }
      this.$set(medal, "id", medalId);
      const isSelected = Number(medal.is_select) === 1;
      const selectedCount = this.getSelectedMedalIds().length;
      if (!isSelected && selectedCount >= 3) {
        return;
      }
      this.$set(medal, "is_select", isSelected ? 0 : 1);
      this.imgIndex = this.getSelectedMedalIds().length;
    },
    async aliOssConfig() {
      //获取oss配置
      let res = await this.$global.multiplefile_token();
      res.code == 200 ? (this.ossConfig = res.data) : {};
    },
    async uploadSectionFile(param, type) {

      this.uploadloading = true;
      let { file } = param;

      try {
        // 获取OSS配置
        await this.aliOssConfig();
        const resultOss = await this.$ossUpload(file, this.ossConfig, {
          onProgress: (percent) => {
            param.onProgress({ percent });
            this.uploadlPercentage = percent;
          }
        });

        param.onSuccess(resultOss);

        //防止重复命名
        const result = await this.$global.ossUrlFind({
          oss_url: `https://xfanstemp.oss-us-west-1.aliyuncs.com${resultOss.name}`,
        });

        if (type == 1) {
          this.dialogVisibleHead = false;
          this.user_info.user_thumb_compress = result.data;
          this.user_info.is_default_face = 0;
          this.avatarPicked = true;
          this.isPresetAvatar = false;
          this.$store.state.userInfo.userInfo.face_url = result.data;
          this.headData.forEach((item) => {
            item.active = false;
          });
        } else if (type == 2) {
          this.upload_img.push({ url: result.data });
          if (this.upload_img.length >= 3) {
            this.$refs.addText.parentNode.style.display = "none";
          }
        } else if (type == 3) {
          this.user_info.user_thumb_compress = result.data;
          this.user_info.is_default_face = 0;
          this.avatarPicked = true; // 自己上传的头像算完成
          this.isPresetAvatar = false;
          this.dialogVisibleHead = false;
          let res = await this.$global.terminusLogin();
        }

        const log = await this.$global.uploadLog({
          url: result.data,
          log_type: 3,
          rand_code: this.randCode,
        });

        this.uploadloading = false;
        this.uploadlPercentage = 0;

      } catch(err) {
        console.error('Upload failed:', err);
        this.uploadloading = false;
        this.$message.error(this.$t("page.UPLOAD_FAILED"));
      }
    },
  },
  created() {},
  mounted() {
    this.getUserInfo();
    document.body.clientWidth <= 768
      ? ((this.dialogWidth = "95%"), (this.headDialogWidth = "95%"))
      : document.body.clientWidth >= 768 && document.body.clientWidth <= 1660
      ? ((this.dialogWidth = "60%"), (this.headDialogWidth = "35%"))
      : ((this.dialogWidth = "40%"), (this.headDialogWidth = "25%"));
    window.onresize = () => {
      document.body.clientWidth <= 768
        ? ((this.dialogWidth = "95%"), (this.headDialogWidth = "95%"))
        : document.body.clientWidth >= 768 && document.body.clientWidth <= 1660
        ? ((this.dialogWidth = "60%"), (this.headDialogWidth = "35%"))
        : ((this.dialogWidth = "40%"), (this.headDialogWidth = "25%"));
    };

    // this.getPession()
    // this.$refs.uploadImg.click()
  },
  watch: {},
};
